import { unitId, actionId } from '@/annotations'
import { NAV_GROUPS } from '@/routes/navigation'
import { LauncherCard } from '@/components/LauncherCard'

/**
 * `v-home` — Prototype_v2.html `#v-home`. **Rebuilt W174**: the previous shape was one
 * `launcher-card` PER GROUP, each containing a bare vertical list of its leaves — a different
 * information architecture from the prototype's own, which is `div.sect` (`section-heading`) per
 * group followed by `div.grid3` of one real `launcher-card` per LEAF (icon, colour, description).
 * The marketing `.banner` (cross-sell to other SpinOne products) is out of scope per
 * `design/27-ui-surface-and-navigation.md` §27.5 A — external links, no route, excluded from the SPA.
 */
export function VHome({ onNavigate }: { onNavigate: (routeId: string) => void }) {
  return (
    <div data-scr={unitId('v-home')}>
      <h1 className="m-0 mb-2 text-display font-bold">Bitbucket Command Center</h1>
      {NAV_GROUPS.map((group) => (
        <section key={group.routeId}>
          <div data-cmp="section-heading" className="text-body-lg font-semibold mt-9 mb-3">
            {group.title}
          </div>
          <div className="grid gap-8" style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(330px, 1fr))' }}>
            {group.leaves.map((leaf) => (
              <LauncherCard
                key={leaf.routeId}
                variant={group.accent}
                icon={leaf.icon}
                title={leaf.title}
                description={leaf.summary}
                actionId={actionId(`nav.${leaf.unitId}`)}
                onClick={() => onNavigate(leaf.routeId)}
              />
            ))}
          </div>
        </section>
      ))}
    </div>
  )
}
